@if (auth.isLoading$ | async) {
  <div class="flex max-h-full">
    <app-loading></app-loading>
  </div>
} @else {
  @if (profile) {
    <app-change-password-content
      [user]="profile"
    ></app-change-password-content>
  }
}

